import { useEffect, useRef, useState } from 'react';
import { runVerifiedSpeedTest } from '../../installer/speedTest';
export default function SpeedTestControl({config,disabled,onResult}) {
 const active = useRef(true);useEffect(() => {active.current = true;return () => {active.current = false;};},[]);
 const [busy,setBusy] = useState(false);const [error,setError] = useState('');
 return <section className="inst-speed-test"><p>ثبت دستی سرعت و عکس دوربین از نتیجه، روش پیش‌فرض است. این آزمون اتصال به مودم مشترک را اثبات نمی‌کند.</p>
  {config?.verified === true && config.url && <button type="button" className="inst-btn inst-btn-ghost" disabled={disabled || busy} onClick={async () => {
   setBusy(true);setError('');try {const values = await runVerifiedSpeedTest(config);if (active.current) await onResult(values);} catch(e) {if (active.current) setError(e.message);} finally {if (active.current) setBusy(false);}
  }}>{busy ? 'در حال آزمون سرعت' : 'آزمون داخلی با سرور تأییدشده'}</button>}
  {error && <p role="alert" className="inst-alert">{error}</p>}
 </section>;
}
